import React from 'react'
import './styles.css'
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action/index";
import {Button, Card, CardBody, CardHeader, Col, Row} from 'reactstrap';
import LabelInput from "../../../components/Input/Input/TxtLbl";
import {MDBDataTable} from 'mdbreact'
import {Button as SementicBtn, Form, Icon, Input} from 'semantic-ui-react'
import {Spin, Tooltip, Icon as AntdIcon} from "antd";
import * as DropDownConst from "../../../store/Reducer/DropDownConst";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import $ from "jquery";
import * as common from "../../../const/Common/CommonFunc";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import swal from "sweetalert";
import Lbl from "../../../components/Label/Lbl";
import * as EmailValidator from "email-validator";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import Update from "./Update/Update";
import apiConfig from "../../../axios/axios_api_services";
import IntlTelInput from "react-intl-tel-input";

class App extends React.Component {

  state = {
    email: "",
    name: "",
    username: "",
    password: "",
    branch_list: [],
    selected_list: [],
    validatePassword: false,
    validEmail: false,
    isLoadReception: false,
    reception_list: [],
    isUpdate: false,
    recept_data: null,
    userRole: "RECEPTION",
    mobile: '', format_mobile: '', valid_mobile: false,
  };

  loadSpin = (type, conditon) => {
    this.setState({
      [type]: conditon
    })
  };

  handleChange = (name, length) => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else if (name === "email") {
      let validateEmail = EmailValidator.validate(value.trim());
      if (validateEmail) {
        this.setState({
          validEmail: true,
          [name]: value
        });
      } else {
        this.setState({
          validEmail: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      selected_list: [value]
    })
  };

  selectUserRole = name => (event, {value}) => {
    this.setState({
      userRole: value
    })
  };

  getAllRecpitons = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "user_type": "RECEPTION"
    };
    this.loadSpin("isLoadReception", true);

    axiosTags.get(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            reception_list: response.data.adminUserList
          })
        } else {
          this.setState({
            reception_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllRecpitons()
        }
      })
      .finally(fin => {
        this.loadSpin("isLoadReception", false);
      });
  };

  clearFeilds = () => {
    this.getAllRecpitons();
    this.getAllBranch();
    this.setState({
      email: "",
      name: "",
      username: "",
      password: "",
      selected_list: [],
      validatePassword: false,
      validEmail: false,
      mobile: '', format_mobile: '', valid_mobile: false,
    });
  };

  addReception = () => {
    this.state.name.trim() === '' ? common.notifyMessage("Please enter full name") :
      this.state.username.trim() === "" ? common.notifyMessage("Please enter username") :
        !this.state.validEmail ? common.notifyMessage("Please enter valid email") :
          !this.state.valid_mobile ? common.notifyMessage("Invalid mobile number") :
            !this.state.validatePassword ? common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS") :
              this.state.selected_list.length === 0 ? common.notifyMessage("Please enter branches") :
                swal({
                  title: "Click YES to add a new receptionist",
                  icon: are_you_sure_icon,
                  closeOnClickOutside: false,
                  buttons: {
                    cancel: 'Cancel',
                    dangerMode: {
                      text: "Yes",
                      value: "action",
                      className: "okay-btn"
                    }
                  },
                }).then((value) => {
                  switch (value) {
                    case "action":
                      this.sendToBackend();
                      break;
                    default:
                      break;
                  }
                });
  };

  sendToBackend = () => {
    const {email, name, username, selected_list, password, userRole,format_mobile} = this.state;
    const obj = {
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": 1,
      "userRoles": userRole,
      "branchId": selected_list,
      "mobile": format_mobile
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.put(apiConfig.CORPORATE_SELECT_SYSTEM_USER(this.props.usr_obj.corporateId), obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Receptionist successfully created - (" + username + ")", 0);
          this.clearFeilds()
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteReception = (id, name) => {
    swal({
      text: "Are you sure you want to delete this receptionist? \n If so please enter \"" + name + "\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteReception_(id)
        } else {
          common.warningAlert("Can't delete Receptionist", 1)
        }
      });
  };
  deleteReception_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_SYSTEM_USER_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Receptionist deleted successfully", 0);
          this.clearFeilds();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteReception_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  updateReception = (obj) => {

    this.setState({
      isUpdate: true,
      recept_data: obj
    })
  };

  getAllBranch = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_BRANCH(this.props.usr_obj.corporateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let branch_options = [];
          if (response.data.branchList.length !== 0) {
            response.data.branchList.map((branch, index) => {

              const obj = {
                key: index,
                text: branch.name,
                value: branch.branchId
              };
              branch_options.push(obj)
            })
          }
          this.setState({
            branch_list: branch_options
          })
        } else {
          this.setState({
            branch_list: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranch()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

  componentDidMount() {
    this.getAllRecpitons();
    this.getAllBranch();
    $('input').attr('autocomplete', 'off');
  }
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };

  render() {
    const rows = [];
    if (this.state.reception_list.length !== 0) {
      this.state.reception_list.map((row, index) => {
        rows.push(
          {
            name: row.fullName,
            userName: row.userName,
            email: row.email,
            role: row.userRoles,
            branch: row.branches.length,
            status: row.status === 1 ? "Active" : "Inactive",
            action:
              <div>
                <SementicBtn circular icon='edit' onClick={() => this.updateReception(row)}/>
                <SementicBtn className="cus-btn" circular icon='trash alternate'
                             onClick={() => this.deleteReception(row.userId, row.userName)}/>
              </div>
          }
        )
      });
    }
    let columns = this.props.table_data.columns;
    let table_data = {columns, rows};

    return (
      <div>
        {
          this.state.isUpdate ?
            <Update data={this.state.recept_data} refreshData={this.clearFeilds}
                    closeModal={() => this.setState({isUpdate: false})}/> : null
        }
        <Card>
          <CardHeader>Manage Receptionist</CardHeader>
          <CardBody>
            <Row>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Full Name</Lbl>
                        <LabelInput
                          placeholder={"Full Name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>User Name</Lbl>
                        <LabelInput
                          placeholder={"User Name"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Email</Lbl>
                        <LabelInput
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Col>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Mobile Number</Lbl>
                        <IntlTelInput
                          type={"text"}
                          fieldName={"Mobile Number"}
                          style={{width: '100%', height: '37px'}}
                          value={this.state.mobile}
                          containerClassName="intl-tel-input dashboard-intl"
                          inputClassName="form-control"
                          onPhoneNumberChange={this.onPhoneNumberChange}
                          required={true}
                          preferredCountries={['lk']}
                          defaultCountry={"lk"}
                          nationalMode={false}
                        />
                      </Col>

                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Choose USER_ROLES</Lbl>
                        <DrpDwn
                          placeholder={"USER_ROLES"}
                          options={DropDownConst.receptionistUserRoles}
                          value={this.state.userRole}
                          onChange={this.selectUserRole('USER_ROLES')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Password</Lbl>
                        <Input id={"password-field"} type={"password"}
                               onChange={this.handleChange('password')}
                               value={this.state.password}
                               style={{width: '100%'}}
                               icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                           onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                               placeholder='Password'/>
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Choose Branches</Lbl>
                        <DrpDwn
                          // multiple
                          placeholder={"Branches"}
                          options={this.state.branch_list}
                          value={this.state.selected_list[0]}
                          onChange={this.dropDownChange('branch')}
                        />
                      </Col>
                    </Form>

                    <Row>
                      <Col className="marginTop" xs={12} sm={12} md={12} lg={12}>
                        <center>
                          <Button
                            className="addBtn yellow-btn"
                            onClick={e => this.addReception(e, 'addReception')}
                          >Add Receptionist</Button>

                          <Tooltip placement="topLeft" title="Clear input fields">
                            <SementicBtn circular icon='refresh' onClick={this.clearFeilds}/>
                          </Tooltip>

                        </center>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardHeader>All Receptionists</CardHeader>
          <CardBody>
            <Spin spinning={this.state.isLoadReception} delay={10}
                  indicator={<AntdIcon type="loading" style={{fontSize: 24}} spin={"true"}/>}>
              <MDBDataTable
                searching={true}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                bordered
                hover
                data={table_data}/>
            </Spin>
          </CardBody>
        </Card>
      </div>
    );
  }

}

const mapStateToProps = (state) => ({
  table_data: state.COPReceptionReducer.receptionTable_data,
  receptionData: state.COPReceptionReducer.receptionData, //un-use
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addReception: (data) => dispatch(actionCreator.addReception(data)),
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
